import { Chip, type TextFieldProps, Typography } from "@mui/material";
import { classes } from "./styles";

export interface IEmailFieldContactsProps extends Pick<TextFieldProps, "size"> {
  contacts: string[];
  limitTags: number;
  onDelete: (index: number) => void;
}

export const EmailFieldContacts = ({ contacts, limitTags, size, onDelete }: IEmailFieldContactsProps) => {
  return (
    <>
      {contacts.map((email, index) => (
        <Chip
          key={email}
          className={classes.chips}
          color="yellow"
          size={size}
          label={email}
          onDelete={() => onDelete(index)}
          onMouseDown={(evt) => evt.preventDefault()}
        />
      ))}
      {contacts.length > limitTags && (
        <Typography className={classes.moreChips} variant="body1">
          +{contacts.length - limitTags}
        </Typography>
      )}
    </>
  );
};
